import styled from 'styled-components';

const TextLabel = styled.div<{ $size?: number; $fw?: number; $color?: string }>`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: ${(props) => props.$fw || 'normal'};
	line-height: normal;
	user-select: none;
	color: ${(props) => props.$color || '#000000'};
	font-size: ${(props) => `${props.$size}px`};
`;

export { TextLabel };
